import React, { FC } from 'react'
import { TooltipComponent } from 'Pages/landings/newLandings/common/components'
import { AdTooltipText } from './AdTooltipText'
import { AdWrapper, Ad } from '../styled'

interface ComponentProps {
	erid: string
	tooltipId?: string
}

export const AdMark: FC<ComponentProps> = ({ erid, tooltipId = 'global' }) => {
	return (
		<AdWrapper>
			<TooltipComponent tooltipId={tooltipId} title={<AdTooltipText erid={erid} />}>
				<Ad>Реклама</Ad>
			</TooltipComponent>
		</AdWrapper>
	)
}
